import { render, staticRenderFns } from "./LiveComment.vue?vue&type=template&id=d723b2ca&scoped=true"
import script from "./LiveComment.vue?vue&type=script&lang=js"
export * from "./LiveComment.vue?vue&type=script&lang=js"
import style0 from "./LiveComment.vue?vue&type=style&index=0&id=d723b2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d723b2ca",
  null
  
)

export default component.exports